/* 动态设置根字号 */
export function setRem() {
  const baseWidth = 1920; // 设计稿宽度
  const baseFontSize = 16; // 基础字体大小
  const clientWidth = document.documentElement.clientWidth || window.innerWidth;
  const scale = clientWidth / baseWidth;
  document.documentElement.style.fontSize = `${baseFontSize * scale}px`;
}

export function initRem() {
  setRem();
  window.addEventListener("resize", setRem);
}
